import { FC } from "react";

import { t } from "i18n/i18n";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { CopySendArrowIcon } from "mds/icons";
import { useClassActions } from "utils/class-utils";

const LeaveClassButton: FC<{ isMobile?: boolean }> = ({ isMobile = false }) => {
  const { leaveClass } = useClassActions();

  return (
    <SquareIconButton
      kind="destructive"
      size={isMobile ? "xl" : "l"}
      title={t("av.leave_virtual_class")}
      onClick={leaveClass}
    >
      <CopySendArrowIcon />
    </SquareIconButton>
  );
};

// Using default export to allow lazy-loading
// eslint-disable-next-line import/no-default-export
export default LeaveClassButton;
